import React from "react";
import PropTypes from "prop-types";
import Cell from "./Cell";
import { Button, Space } from "antd";
import { PlusOutlined, MinusCircleFilled } from "@ant-design/icons";
import styles from "./styles.module.css";

function IndexColGroup(props) {
  const elemArray = props.cols.map((el, index) => (
    <td
      key={index}
      className={styles.index_column_td}
      style={{
        width: props.type === 2 && index === 0 ? 266 : 250,
        paddingLeft: props.type === 2 && index === 0 ? 16 : 0,
      }}
    >
      <div style={{ position: "relative" }}>
        <div className={styles.index_column_td_div}>
          <Cell
            value={el.index_id}
            list={props.getColumns(el.index_id)}
            type={props.type}
            elem={el}
            updateDataRecord={props.updateColumn}
          />
        </div>
        {props.cols.length > 1 ? (
          <MinusCircleFilled
            onClick={() => {
              props.removeColumn(el.uniqueId);
            }}
            style={{ position: "absolute", right: 0, top: 0 }}
          />
        ) : null}
      </div>
    </td>
  ));
  return elemArray;
}

// IndexColGroup.propTypes = {

// }

export default IndexColGroup;
